<template>
  <div v-if="cluster" class="modal-content-frame">
    <div class="zone-header zone-header__inline">
      <label for="name">Cluster Label *</label>
      <div>
        <InputText
          id="name"
          v-model="cluster.name"
          placeholder="What's the cluster name?"
          :invalid="!hasUniqueName"
        />
        <div v-if="!hasUniqueName" class="input-error-text">
          Each cluster must have a unique name
        </div>
      </div>
    </div>

    <div class="zone-header">
      <div>
        <label for="chips">Cluster Category *</label>
        <p>Select one or more types</p>
      </div>
    </div>

    <div class="chips">
      <Chip
        v-for="cat in eventsStore.eventList?.cluster_category"
        :key="cat.id"
        :isToggle="true"
        :colored="cluster.categories.includes(cat.id)"
        :canDelete="cluster.categories.includes(cat.id)"
        @chipClicked="chipClicked(cat.id)"
      >
        {{ cat.name }}
      </Chip>
    </div>

    <div class="zone-header">
      <div>
        <label for="chips">Zones</label>
        <p>List of zones in this cluster. A cluster must have at least 1 zone.</p>
      </div>
      <Button severity="primary" @click="goToStageTwo()">
        <IconPlus />
        Add
      </Button>
    </div>

    <ul class="zone-sensor-list" v-if="cluster.zones?.length">
      <ZonePreview
        v-for="(zone, index) in cluster.zones"
        :key="index"
        v-model:zone="cluster.zones[index]"
        v-model:checkedZones="cluster.zones"
        :canEdit="false"
        :canRemove="true"
        :showTypes="true"
        :showCheck="false"
        :index="index"
        :active="cluster.zones.includes(zone)"
        @onRemoveZone="onRemoveZone(index)"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { EventTypeNew, ClusterType } from '@/types/Event';

import InputText from '@/components/inputs/InputText.vue';
import { Button } from 'primevue';

import Chip from '@/components/global/Chip.vue';
import ZonePreview from '@/components/events/ZonePreview.vue';

import IconPlus from '@/icons/IconPlus.svg?component';

import { useEventsStore } from '@/stores/events';
const eventsStore = useEventsStore();

const newEvent = defineModel<EventTypeNew>('newEvent');
const cluster = defineModel<ClusterType>('cluster');

const emit = defineEmits(['changeStage']);

const chipClicked = (catId: number) => {
  if (cluster.value?.categories.includes(catId)) {
    cluster.value?.categories.splice(cluster.value?.categories.indexOf(catId), 1);
  } else {
    cluster.value?.categories.push(catId);
  }
};

const hasUniqueName = computed(() => {
  let nameUnique = true;

  newEvent.value?.clusters.forEach((savedCluster) => {
    if (savedCluster.name.toLowerCase().trim() === cluster.value?.name.toLowerCase().trim()) {
      nameUnique = false;
    }
  });

  return nameUnique;
});

const onRemoveZone = (index: number) => {
  cluster.value?.zones.splice(index, 1);
};

const goToStageTwo = () => {
  emit('changeStage');
};
</script>
